import React from "react";
import {Control} from "react-hook-form/dist/types";
import {Controller, FieldPath} from "react-hook-form";
import {FieldValues} from "react-hook-form/dist/types/fields";
import {LavoratorePresenzeRecord} from "@commons/mapping/LavoratorePresenzeRecord";
import BigComboBox from "@components/comboBox/BigComboBox";

interface ComboBoxLavoratoriProps<TFieldValues extends FieldValues> {
    control: Control<TFieldValues>,
    name: FieldPath<TFieldValues>,
    defaultValue: any,
    label: string,
    data: LavoratorePresenzeRecord[] | null
    isLoading?: boolean,
    onChange?: (lavoratore: LavoratorePresenzeRecord | null) => void,
}

export function ComboBoxLavoratori<T extends FieldValues>(props: ComboBoxLavoratoriProps<T>) {
    const {control, name, defaultValue, label, data, isLoading, onChange: onChangeAux} = props;
    return <Controller name={name}
                       control={control}
                       defaultValue={defaultValue}
                       rules={{required: true}}
                       render={({field: {value, onChange}, fieldState}) => {
                           const val = {id: value};
                           return (
                               <BigComboBox<LavoratorePresenzeRecord> label={label}
                                                                      value={val}

                                                                      onChange={(value) => {
                                                                          onChange(value?.id)
                                                                          if (onChangeAux)
                                                                              onChangeAux(value);
                                                                      }}

                                                                      fieldState={fieldState}
                                                                      data={data ? data : undefined}
                                                                      searchablePropsName={["cognome", "nome", "codDip"]}
                                                                      isLoading={isLoading}

                                                                      isSameFn={(a, z) => (a && z) ? a.id === z.id : false}
                                                                      keyValueFn={(v) => v.id!}
                                                                      displayValueFn={(v) => data && v ? `${v.cognome} ${v.nome} [${v.codDip}]` : ''}
                               />
                           )
                       }}
    />
}

export default ComboBoxLavoratori;